export default "__VITE_ASSET__DEoh2hbt__"